<div class="audit-log-show-details-dialog">
    <p-table [value]="[data]" [scrollable]="true" scrollHeight="400px">
        <ng-template #header>
            <tr>
                <th scope="col">{{'adminAuditLog.dialog.showDetails.tableHeader.information' | transloco}}</th>
                <th scope="col">{{'adminAuditLog.dialog.showDetails.tableHeader.content' | transloco}}</th>
            </tr>
        </ng-template>
        <ng-template #body>
            <tr>
                <td>{{ 'adminAuditLog.dialog.showDetails.tableRow.action' | transloco }}</td>
                <td>{{ action }}</td>
            </tr>
            <tr *ngIf="data?.page">
                <td>{{ 'adminAuditLog.dialog.showDetails.tableRow.page' | transloco }}</td>
                <td>
                    <a [href]="data.page" target="_blank" aria-describedby="linkOpensInNewTab">{{ data.page }}</a>
                </td>
            </tr>
            <tr *ngIf="data?.comment">
                <td>{{ 'adminAuditLog.dialog.showDetails.tableRow.comment' | transloco }}</td>
                <td>{{ data.comment }}</td>
            </tr>
            <tr *ngIf="data?.source_code">
                <td>{{ 'adminAuditLog.dialog.showDetails.tableRow.sourceCode' | transloco }}</td>
                <td>
                    <pre class="text-wrap">{{ data.source_code }}</pre>
                </td>
            </tr>
            <tr *ngIf="data?.check_id">
                <td>{{ 'adminAuditLog.dialog.showDetails.tableRow.check' | transloco }}</td>
                <td>
                    <div [innerHTML]="name"></div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="tw-flex tw-justify-end tw-mt-6" *ngIf="!isAnUndoLog() && canUndo()">
        <p-button 
            class="tw-mr-4"
            [label]="'adminAuditLog.dialog.showDetails.buttonLabel.undo' | transloco"
            severity="primary"
            (onClick)="undoAccessibilityCheck()"
            />
    </div>
</div>